import * as React from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
} from 'react-admin';
import AzureAuthenticationTitle from './AzureAuthenticationTitle';

const AzureAuthenticationEdit = props => (
    <Edit title={<AzureAuthenticationTitle />} {...props}>
        <SimpleForm>
            <TextInput source="name" label="Name" />
            <TextInput source="client_id" label="Client ID" />
            <TextInput source="client_secret" label="Client secret" />
            <TextInput source="tenant_id" label="Tenant ID" />
            <TextInput source="subscription_id" label="Subscription ID" />
        </SimpleForm>
    </Edit>
);

export default AzureAuthenticationEdit;